import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonServices } from 'src/app/Services/common.service';

@Component({
  selector: 'g10-rostering-emp-type-change',
  templateUrl: './rostering-emp-type-change.component.html',
  styleUrls: ['./rostering-emp-type-change.component.css']
})
export class RosteringEmpTypeChangeComponent implements OnInit {

  @Input() popup = false;
  @Input() selectedEmp: any;
  @Input() routeData: any;
  // @Input() ppData:any;
  @Output() close = new EventEmitter();
  @Output() changedDuration = new EventEmitter();

  public objKeys = Object.keys;

  empTypeChangeForm = {
    isTemp:false,
  };
  public errorObject = {};
  public isTemp = 'false';
  public invalidDate:boolean = false;
  public minDate;
  public maxDate;
  public defaultFromDate='';
  public defaultToDate='';
  public showDatePicker:boolean = true;


  public formSubmitted:boolean = false;
  constructor(private comservice:CommonServices) { }

  ngOnInit(): void {
    setTimeout(()=>{ 
      if(Object.keys(this.routeData).length>0){
        this.showDatePicker = false;
        let fDate = new Date(this.routeData.fromDate);
        this.minDate = fDate.getFullYear()+"-"+this.comservice.pad(fDate.getMonth()+1)+"-"+this.comservice.pad(fDate.getDate());
        if(this.routeData['toDate']){
          let tDate = new Date(this.routeData.toDate);
          this.maxDate = tDate.getFullYear()+"-"+this.comservice.pad(tDate.getMonth()+1)+"-"+this.comservice.pad(tDate.getDate());
        }
        this.showDatePicker = true;
      }
      this.updateForm(this.selectedEmp);
    },100);
  }

  updateForm(obj){
    if(obj.isTemp){
      this.isTemp = 'true';
      this.empTypeChangeForm.isTemp = true;
      this.showDatePicker = false;
      this.defaultFromDate = this.comservice.timestampToDate(obj['fromDate'], 'YMD', '-');
      this.defaultToDate = this.comservice.timestampToDate(obj['toDate'], 'YMD', '-');
      this.empTypeChangeForm['fromDate'] = obj.fromDate;
      this.empTypeChangeForm['toDate'] = obj.toDate;
      this.showDatePicker = true;
    }
    else this.empTypeChangeForm.isTemp = false;
  }

  showFormDates(e){
    if(e.target.value == 'true'){
      this.empTypeChangeForm.isTemp = true;
      this.empTypeChangeForm['fromDate'] = '';
      this.empTypeChangeForm['toDate'] = '';
    }
    else{
      this.empTypeChangeForm.isTemp = false;
      delete this.empTypeChangeForm['fromDate'];
      delete this.empTypeChangeForm['toDate'];
    }
    if(this.formSubmitted) this.validation();
  }

  dateFromAction(obj: any = {}, type) {
    obj.selectedDates.map((x: any) => {
      let timeStamp = x.getTime();
      this.empTypeChangeForm[type] = timeStamp;
    });
    if(this.formSubmitted) this.validation();
}

  validation() {
    let objectKeys = Object.keys(this.empTypeChangeForm);
    this.errorObject = {};
    let isValid = true;
    this.errorObject['invalidDate'] = '';
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (key!='isTemp' && (this.empTypeChangeForm[key] == '' || this.empTypeChangeForm[key] == undefined || this.empTypeChangeForm[key] == null || this.empTypeChangeForm[key].length <= 0)) {
          this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        isValid = false;
      } else if (key == 'fromDate' || key == 'toDate') {
          this.invalidDate = false;
        if ((this.empTypeChangeForm['toDate'] !='') && this.empTypeChangeForm['fromDate'] > this.empTypeChangeForm['toDate']) {
          isValid = false;
          this.invalidDate = true;
          this.errorObject['invalidDate'] = 'To Date is Invalid.';
        }
      }
    }
    return isValid;
  }

  onSubmit(){
    this.formSubmitted = true;
    let isValid = this.validation();
    if(isValid){
      let obj = {
        routeID:this.routeData.routeID,
        // pickupPointID:this.ppData.pickupPointID,
        employeeID:this.selectedEmp.employeeID,
        ...this.empTypeChangeForm
      }
      this.changedDuration.emit(obj);
      this.closePopup();
    }
  }
  closePopup(){
    this.close.emit(true);
  }
}
